module.exports = __webpack_public_path__ + "img/taili9.84530e9c.jpg";